export const middleWare = (store) => (next) => (action) => {
  console.log("action received ", action);

  const result = next(action);

  return result;
};
